import { application } from './application'
import StimulusControllerResolver, { createViteGlobResolver } from 'stimulus-controller-resolver'
import DropdownController from './dropdown_controller'

// Dropdowns are on every page, from the navbar to every form select: registered upfront,
// they are set up on the first render instead of after their chunk loads.
application.register('dropdown', DropdownController)

StimulusControllerResolver.install(application, createViteGlobResolver(
  import.meta.glob(['./**/*_controller.ts', '!./dropdown_controller.ts']),
  import.meta.glob('./../../components/**/*_controller.ts')
))
